module.exports = __webpack_public_path__ + "img/icon1.64df2470.png";